import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBrackets16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextBrackets16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.107 5.166a2.25 2.25 0 0 0-2.25-2.25H11.78a.5.5 0 0 0 0 1h1.078c.69 0 1.25.56 1.25 1.25v6.584c0 .69-.56 1.25-1.25 1.25H11.78a.5.5 0 0 0 0 1h1.078a2.25 2.25 0 0 0 2.25-2.25zM4.797 6.5a.5.5 0 0 1 .5-.5h5.657a.5.5 0 1 1 0 1H5.296a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 1 0 0 1h5.657a.5.5 0 1 0 0-1zm-.5 2.5a.5.5 0 0 1 .5-.5h3.535a.5.5 0 0 1 0 1H5.296a.5.5 0 0 1-.5-.5M3.25 3A2.25 2.25 0 0 0 1 5.25v6.5A2.25 2.25 0 0 0 3.25 14h1.079a.5.5 0 1 0 0-1H3.25C2.56 13 2 12.44 2 11.75v-6.5C2 4.56 2.56 4 3.25 4h1.079a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBrackets16);
